import React from "react";

export default function StarIcon() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.51622 0.417433L4.00781 3.52017L0.632943 4.01933C0.0277306 4.10838 -0.214816 4.86532 0.224078 5.29886L2.66572 7.71262L2.08822 11.1224C1.98427 11.7387 2.62414 12.2004 3.16005 11.9121L6.17918 10.3021L9.19831 11.9121C9.73422 12.198 10.3741 11.7387 10.2701 11.1224L9.69264 7.71262L12.1343 5.29886C12.5732 4.86532 12.3306 4.10838 11.7254 4.01933L8.35055 3.52017L6.84214 0.417433C6.57187 -0.135624 5.78879 -0.142654 5.51622 0.417433Z"
        fill="#F2994A"
      />
    </svg>
  );
}
